export const GET_CANCELLATION_REASON = "GET_CANCELLATION_REASON"
export const GET_CANCELLATION_REASON_SUCCESS = "GET_CANCELLATION_REASON_SUCCESS"
export const GET_CANCELLATION_REASON_FAIL = "GET_CANCELLATION_REASON_FAIL"

export const ADD_CANCELLATION_REASON = "ADD_CANCELLATION_REASON"
export const ADD_CANCELLATION_REASON_SUCCESS = "ADD_CANCELLATION_REASON_SUCCESS"
export const ADD_CANCELLATION_REASON_FAIL = "ADD_CANCELLATION_REASON_FAIL"

export const UPDATE_CANCELLATION_REASON = "UPDATE_CANCELLATION_REASON"
export const UPDATE_CANCELLATION_REASON_SUCCESS = "UPDATE_CANCELLATION_REASON_SUCCESS"
export const UPDATE_CANCELLATION_REASON_FAIL = "UPDATE_CANCELLATION_REASON_FAIL"

export const DELETE_CANCELLATION_REASON = "DELETE_CANCELLATION_REASON"
export const DELETE_CANCELLATION_REASON_SUCCESS = "DELETE_CANCELLATION_REASON_SUCCESS"
export const DELETE_CANCELLATION_REASON_FAIL = "DELETE_CANCELLATION_REASON_FAIL"

export const SET_CANCELLATION_REASON_FIELD_ERRORS = "SET_CANCELLATION_REASON_FIELD_ERRORS"
